export default "__VITE_ASSET__ce78fea8__"